"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DataType_1 = __importDefault(require("@opsbase/lib-datatype/DataType"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const DataPill_1 = __importDefault(require("@opsbase/web-chips/DataPill"));
const Pill_1 = __importDefault(require("@opsbase/web-chips/Pill"));
const react_1 = __importStar(require("react"));
const SuperUserOrgsRendererFactory = () => (superUser) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const orgs = (0, react_1.useMemo)(() => {
        var _a, _b;
        return ((_b = (_a = superUser === null || superUser === void 0 ? void 0 : superUser.allowedOrgs) === null || _a === void 0 ? void 0 : _a.map(z => (react_1.default.createElement(DataPill_1.default, { type: DataType_1.default.ORGANISATION, value: z.title })))) !== null && _b !== void 0 ? _b : []);
    }, [superUser]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const orgTags = (0, react_1.useMemo)(() => {
        var _a, _b;
        return ((_b = (_a = superUser === null || superUser === void 0 ? void 0 : superUser.allowedOrgTags) === null || _a === void 0 ? void 0 : _a.map(z => (react_1.default.createElement(Pill_1.default, { value: `Tag: ${z}`, backgroundColor: lib_palette_1.default.Grey })))) !== null && _b !== void 0 ? _b : []);
    }, [superUser]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        orgs.length ? orgs : null,
        orgTags.length ? orgTags : null));
};
exports.default = SuperUserOrgsRendererFactory;
